export default {
	messages: {
		required: (field) => "Aquest camp és requerit",
		length: (field) => "El camp està mal format",
		max: (field) => "El camp està mal format",
		min: (field) => "El camp no té la longitud mínima requerida",
		integer: (field) => "El camp està mal format",
		digits: (field) => "El camp està mal format",
		regex: (field) => "El camp està mal format, ha de ser un número",
		numeric: (field) => "El camp està mal format",
		email: (field) => "El camp adreça electrònica està mal format"
	},
	custom: {
		email: {
			required: "El camp adreça electrònica és obligatori",
			email: "Heu d'indicar una adreça de correu electrònic vàlida"
		},
		email_firmante: {
			email: "Heu d'indicar una adreça de correu electrònic vàlida"
		},
		telefono: {
			required: "El camp telèfon és obligatori",
			length: "El camp telèfon està mal format",
			min: "El camp telèfon està mal format",
			max: "La longitud del telèfon és excessiva"
		},
		nombre: {
			required: "El camp nom és obligatori"
		},
		mensaje: {
			required: "El camp localitat és obligatori"
		},
		apellidos: {
			required: "El camp cognoms és obligatori"
		},
		cif: {
			required: "El camp CIF és obligatori",
			length: "El camp CIF està mal format",
		},
		nombre_usuario: {
			required: "El camp nom d'usuari és obligatori"
		},
		puesto: {
			required: "El camp lloc és obligatori"
		},
		telefono: {
			required: "El camp telèfon és obligatori",
			length: "El camp telèfon està mal format",
			min: "El camp telèfon està mal format",
			max: "La longitud del telèfon és excessiva"
		},
		telefono_empresa: {
			required: "El camp telèfon és obligatori",
			length: "El camp telèfon està mal format",
			min: "El camp telèfon està mal format",
			max: "La longitud del telèfon és excessiva"
		},
		telefono2: {
			required: "El camp telèfon és obligatori",
			length: "El camp telèfon està mal format",
			min: "El camp telèfon està mal format",
			max: "La longitud del telèfon és excessiva"
		},
		sede: {
			required: "El camp seu és obligatori"
		},
		experiencia: {
			required: "El camp experiència és obligatori"
		},
		password: {
			required: "El camp contrasenya és obligatori",
			min: "La contrasenya ha de tenir almenys 8 caràcters",
			confirmed: "Les contrasenyes no coincideixen",
			digits: "La contrasenya ha de contenir almenys un número"
		},
		password2: {
			required: "El camp contrasenya és obligatori",
			min: "La contrasenya ha de tenir almenys 8 caràcters",
			confirmed: "Les contrasenyes no coincideixen",
			digits: "La contrasenya ha de contenir almenys un número"
		},
		politica: {
			required: "Heu d'acceptar la política de privadesa"
		},
		direccion: {
			required: "El camp adreça és obligatori"
		},
		cp: {
			required: "El campo codi postal és obligatori"
		},
		pais: {
			required: "El camp país és obligatori"
		},
		paiscontacto: {
			required: "El camp país és obligatori"
		},
		file: {
			size: "La mida màxima són 2MB",
			mimes: "El format ha de ser PDF"
		},
		filePoliza: {
			size: "La mida màxima són 2MB",
			mimes: "El format ha de ser PDF"
		},
		titulo: {
			required: 'El campo nombre de la oferta es obligatorio'
		},
		plazas: {
			required: 'El campo numero de plazas es obligatorio'
		},
		poblacion: {
			required: 'El campo población es obligatorio'
		},
		localidad: {
			required: 'El campo localidad es obligatorio'
		},
		provincia: {
			required: 'El campo provincia es obligatorio'
		},
		provinciacontacto: {
			required: 'El campo provincia es obligatorio'
		},
		horario: {
			required: 'El campo horario de trabajo es obligatorio'
		},
		horasAldia: {
			required: 'El campo horas al día es obligatorio',
			numeric: 'El campo horas al d´´ia debe ser un valor numérico'
		},
		ayudaEstudio: {
			required: "El camp remuneració és obligatori",
			numeric: "El camp remuneració ha de ser un valor numèric",
			decimal: "El camp remuneració ha de ser un valor numèric"
		},
		meses: {
			between: "Ha de ser un valor entre 0 i 12"
		},
		salario: {
			required: "El camp remuneració és obligatori"
		},
		remuneraciones: {
			required: "El camp altres remuneracions és obligatori"
		},
		tiempoDedicacionJornada: {
			between: "Ha de ser un valor entre 0 i 100"
		},
		numeroDiasSemana: {
			between: "Ha de ser un valor entre 1 i 7 "
		},
		otrasRemuneraciones: {
			required: "El camp altres remuneracions és obligatori"
		},
		contrato: {
			required: "El camp tipus de contracte és obligatori"
		},
		descripcion: {
			required: "El camp descripció és obligatori"
		},
		curso: {
			required: "El camp curs és obligatori"
		},
		titulacion: {
			required: "El camp titulació és obligatori"
		},
		puestoTrabajo: {
			required: "El camp lloc de treball és obligatori"
		},
		horasDia: {
			required: "El camp hores al dia és obligatori"
		},
		departamento: {
			required: "El camp departament és obligatori"
		},
		nombreTutorEmpresa: {
			required: "El camp nom del tutor de l'empresa és obligatori"
		},
		ApellidosTutorEmpresa: {
			required: "El camp llinatges del tutor de l'empresa és obligatori"
		},
		emailTutorEmpresa: {
			required: "El camp adreça electrònica del tutor de l'empresa és obligatori",
			email: "El camp adreça electrònica del tutor de l'empresa està mal format"
		},
		titulacionTutorEmpresa: {
			required: "El camp titulació del tutor de l'empresa és obligatori"
		},
		nombreTutorUni: {
			required: "El camp nom del tutor de la universitat és obligatori"
		},
		tareasAdesarrollar: {
			required: "El camp tasques a desenvolupar és obligatori"
		},
		nombreFiscal: {
			required: "El camp nom fiscal és obligatori"
		},
		nombreComercial: {
			required: "El camp nom comercial és obligatori"
		},
		codigo_postal: {
			required: "El camp codi postal és obligatori"
		},
		area_funcional: {
			required: "El camp àrea funcional és obligatori"
		},
		nombre_comercial: {
			required: "El camp nom comercial és obligatori"
		},
		nombre_fiscal: {
			required: "El camp nom fiscal és obligatori"
		},
		listado_titulaciones: {
			required: "Heu de triar almenys una titulació a la qual s'adreça l'oferta"
		},
		privada: {
			required: "El camp tipus de contracte és obligatori"
		},
		tipoEmpresa: {
			min_value: "El camp tipus de contracte és obligatori",
			required: "El camp tipus de contracte és obligatori"
		},
		sector: {
			required: "El camp sector és obligatori"
		},
		startup: {
			required: "El camp empresa emergent és obligatori"
		},
		url: {
			url: "La URL està mal formada"
		},
		checkdni: {
			checkdni: "El DNI està mal format. Introduïu 8 dígits i una lletra majúscula"
		},
		iban: {
			checkiban: "L'IBAN està mal format. Introduïu 8 dígits i una lletra majúscula"
		},
		urlInscripcionExterna: {
			regex: "La URL conté errors"
		},
		linkedin: {
			regex: "La URL conté errors"
		},
		nota: {
			between: "La dada ha d'estar entre 1 i 4"
		},
		vacacionesConvenio: {
			regex: 'El campo dies de vacances conveni ha de ser un valor numèric vàlid'
		},
		horasAnuales: {
			regex: 'El camp Nº de hores anuals ha de ser un valor numèric vàlid'
		},
	}
}


// WEBPACK FOOTER //
// ./submodules/dotia-base-fp/src/validator/ca.js